import React from 'react'
import { Modal, Button, notification } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { QrCodeFormData, QrCodeState } from 'Types/QrCode.d'

interface QrCodePreviewModalProps {
  formData: QrCodeFormData
  state: QrCodeState
  onClose: () => void
}

const QrCodePreviewModal: React.FC<QrCodePreviewModalProps> = ({
  formData,
  state,
  onClose
}) => {
  const handleDownload = () => {
    if (state.previewImage) {
      const link = document.createElement('a')
      link.href = state.previewImage
      const filename = state.previewTitle?.includes("White on") 
        ? `${state.previewTitle.replace(' - QR Code (White on Transparent)', '')}_white_on_transparent.png` 
        : `${state.previewTitle.replace(' - QR Code (Black on Transparent)', '')}_black_on_transparent.png`;
      link.download = filename;
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      notification.success({
        message: 'Download complete',
        description: `Downloaded ${state.previewTitle} with transparent background`,
        duration: 2
      })
    }
  }

  return (
    <Modal
      visible={state.previewVisible}
      title={<span className="font-semibold">{state.previewTitle}</span>}
      footer={null}
      onCancel={onClose}
      width={700}
      centered
      className="qr-preview-modal"
    >
      <div className="flex justify-center p-4 rounded">
        <div className={state.previewTitle?.includes("White on") ? "checker-bg-dark p-4 rounded" : "checker-bg p-4 rounded"}>
          <img src={state.previewImage} style={{ maxWidth: '100%', maxHeight: '60vh' }} alt="QR Code Preview" />
        </div>
      </div>
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-500 mb-3">
          This QR code is generated at {formData.qrWidth}x{formData.qrWidth}px resolution with a transparent background, suitable for high-quality printing.
        </p>
        <Button 
          type="primary" 
          icon={<DownloadOutlined />} 
          className="bg-blue-500 hover:bg-blue-600"
          onClick={handleDownload}
        >
          Download this QR Code
        </Button>
      </div>
    </Modal>
  )
}

export default QrCodePreviewModal 